let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("f7cnZ")).then(() => parcelRequire('6ALZ6'));